import { render, staticRenderFns } from "./type-content.vue?vue&type=template&id=065cd8d0&scoped=true&"
import script from "./type-content.vue?vue&type=script&lang=js&"
export * from "./type-content.vue?vue&type=script&lang=js&"
import style0 from "./type-content.vue?vue&type=style&index=0&id=065cd8d0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065cd8d0",
  null
  
)

export default component.exports